<template>
  <b-card class="paragraph mb-3">
    <div :class="paragraphStatusClasses()" v-b-popover.hover.left="paragraphPopoverContent()"></div>
    <b-row>
      <b-col cols="auto" class="d-flex align-items-center flex-column justify-content-center">
        <div class="paragraph__drag-handle">
          <svg viewBox="0 0 421.285 421.285"><path d="M418.742,203.942c-0.3-0.2-0.5-0.5-0.8-0.8l-50.6-44.8c-4.1-3.6-10.5-3.2-14.1,0.9c-3.6,4.1-3.2,10.4,0.8,14l30.9,27.4h-164.3v-164.3l27.3,30.8c3.7,4.1,10,4.5,14.1,0.8s4.5-10,0.8-14.1l-44.8-50.5c-3.7-4.1-10-4.5-14.1-0.8c-0.3,0.3-0.6,0.5-0.8,0.8l-44.8,50.5c-3.6,4.1-3.2,10.5,0.9,14.1c4.1,3.6,10.4,3.2,14-0.8l27.3-30.8v164.3h-164.2l30.8-27.3c4.1-3.7,4.5-10,0.8-14.1c-3.7-4.1-10-4.5-14.1-0.8l-50.5,44.8c-4.1,3.7-4.5,10-0.8,14.1c0.3,0.3,0.5,0.6,0.8,0.8l50.5,44.8c4.1,3.6,10.5,3.2,14.1-0.9c3.6-4.1,3.2-10.4-0.8-14l-30.8-27.4h164.3v164.3l-27.3-30.8c-3.7-4.1-10-4.5-14.1-0.8c-4.1,3.7-4.5,10-0.8,14.1l44.8,50.5c3.7,4.1,10,4.5,14.1,0.8c0.3-0.3,0.6-0.5,0.8-0.8l44.8-50.5c3.6-4.1,3.2-10.5-0.9-14.1c-4.1-3.6-10.4-3.2-14,0.8l-27.4,30.8v-164.3h164.3l-30.8,27.3c-4.1,3.7-4.5,10-0.8,14.1c3.7,4.1,10,4.5,14.1,0.8l50.5-44.8C422.042,214.342,422.442,208.042,418.742,203.942z"/></svg>
        </div>
        <div class="paragraph__order">{{ paragraph.order }}</div>
      </b-col>
      <b-col>
        <div class="paragraph__title">
          <router-link
            :to="{
              name: 'MonitorsParagraphsObjects',
              params: {
                monitorId: monitorCurrent.monitor.id,
                chapterId: monitorCurrent.chapter.id,
                paragraphId: paragraph.id,
              }
            }"
            @click.native="setCurrentParagraph()"
          >
            {{ paragraph.name }}   
          </router-link>     
        </div>
        <p class="paragraph__last-updated" v-if="paragraph.updated_at"><small>Last update {{ paragraph.updated_at | moment('YYYY-MM-DD') }}</small></p>
      </b-col>
      <b-col cols="auto">
        <div class="paragraph__actions">
          <button class="paragraph__action mr-2" @click="requestParagraphEdit()" v-b-popover.hover.top="'Edit'">
            <svg viewBox="0 0 488.471 488.471"><path d="m166.093 240.214h88.205v194.288h-88.205z" transform="matrix(.707 -.707 .707 .707 1.415 9.959)"/><path d="m245.547 105.541-245.547 245.547v137.382h137.382l245.548-245.547z"/></svg>
          </button>
          <button class="paragraph__action mr-2" @click="paragraphDuplicate()" v-b-popover.hover.top="'Duplicate'">
            <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m407 15v90h90zm0 0"/><path d="m377 135v-135h-197v60h44.425781l8.789063 8.785156 120 120 8.785156 8.789063v224.425781h150v-287zm0 0"/><path d="m227 195h90l-90-90zm0 0"/><path d="m197 90h-197v422h332v-287h-135zm0 0"/></svg>
          </button>
          <button class="paragraph__action" @click="requestParagraphDelete()" v-b-popover.hover.top="'Delete'">
            <svg viewBox="0 0 515.556 515.556"><path d="m64.444 451.111c0 35.526 28.902 64.444 64.444 64.444h257.778c35.542 0 64.444-28.918 64.444-64.444v-322.222h-386.666z"/><path d="m322.222 32.222v-32.222h-128.889v32.222h-161.111v64.444h451.111v-64.444z"/></svg>
          </button>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { mapGetters } from "vuex";

import {
  MONITOR_PARAGRAPH_DUPLICATE
} from "@/store/actions.type";

import {
  STATE_MONITORS_CURRENT_PARAGRAPH_SET
} from "@/store/mutations.type";

export default {
  name: 'MonitorParagraph',
  props: ['paragraph'],
  data() {
    return {
      isLoading: true
    }
  },
  computed: {
    ...mapGetters(["monitorTags", "monitorCurrent"]),
  },
  methods: {
    getParagraphObjects() {

    },
    requestParagraphEdit() {
      this.$emit('requestParagraphEdit', this.paragraph);
    },
    requestParagraphDelete() {
      this.$emit('requestParagraphDelete', this.paragraph);
    },
    paragraphPopoverContent() {
      if(this.paragraph.paragraph_is_empty === true) {
        return 'Empty'
      } else if(this.paragraph.published === false) {
        return 'Draft'
      } else {
        return 'Online'
      }
    },
    paragraphStatusClasses() {
      return {
        'paragraph__status': true,
        'paragraph__status--draft': this.paragraph.published === false,
        'paragraph__status--empty': this.paragraph.paragraph_is_empty === true, 
        'paragraph__status--published': this.paragraph.published === true
      }
    },
    setCurrentParagraph() {
      this.$store.commit(STATE_MONITORS_CURRENT_PARAGRAPH_SET, this.paragraph);
    },
    paragraphDuplicate() {
      // let paragraphData = new FormData();
      // paragraphData.append('ids', this.paragraph.paragraph_id);

      this.$store.dispatch(MONITOR_PARAGRAPH_DUPLICATE, this.paragraph.id).then(() => {
        this.$bvToast.toast(`Paragraph ${this.paragraph.name} has been duplicated`, {
          title: 'Paragraph duplicated',
          toaster: 'b-toaster-bottom-right',
          autoHideDelay: 40000,
          variant: 'primary'
        });
        this.$emit('paragraphDuplicated');
      });  
    },
  },
  mounted() {
    this.getParagraphObjects();
  }
}
</script>

<style lang="scss" scoped>
.paragraph {
  position: relative;

  &__status {
    position: absolute;
    left: 0;
    top: 0;
    width: rem(10px);
    height: 100%;
    border-top-left-radius: rem(8px);
    border-bottom-left-radius: rem(8px);
    z-index: 1;

    &--draft {
      background-color: $color-sunset;
    }

    &--published {
      background-color: $color-genoa;
    }

    &--empty {
      background-color: $color-abbey;
    }
  }

  &__drag-handle {

    svg {
      width: rem(20px);
      height: rem(20px);
    }

    &:hover {
      cursor: move;
    }
  }

  &__drag-ghost {
    opacity: 0.5;
  }

  &__order {
    font-size: 0.6125rem;
    padding: 0.125rem 0.25rem;
    text-transform: uppercase;
    display: inline-block;
    line-height: 1;
    margin-top: 0.5rem;
    background: rgba(0,0,0,.1);
    color: #000;
    font-weight: 700;
  }

  &__title {
    color: $color-abbey;
    font-weight: 700;
    font-size: rem(20px);
    margin-bottom: 0;

    a {
      color: $color-abbey;
      transition: color .3s ease;

      &:hover {
        color: $color-java;
        text-decoration: none;
      }
    }
  }

  &__actions {
    margin-bottom: rem(16px);
  }

  &__action {
    margin: 0;
    padding: 0;
    border: 0;
    background: none;

    &:focus {
      outline: none;

      svg {
        fill: $color-genoa;
      }
    }

    svg {
      width: rem(16px);
      height: rem(16px);
      fill: $color-genoa;
      transition: fill .3s ease;

      &:hover {
        fill: $color-java;
      }
    }
  }

  &__last-updated {
    color: $color-abbey;
    text-transform: uppercase;
    margin-bottom: 0;
  }
}
</style>